export default "__VITE_ASSET__DV8VTmZ3__"